<template>
  <v-row class="mb-5 mt-5">
    <v-col cols="6">
      <v-card align="center" flat class="card dt-border">
        <p class="dt-orange__text">TRADE AMOUNT</p>
        <span>{{ amount }}</span>
      </v-card>
    </v-col>
    <v-col cols="6">
      <v-card align="center" flat class="card dt-border">
        <p class="dt-orange__text">STORE</p>
        <span>{{ store }}</span>
      </v-card>
    </v-col>
    <v-col cols="6">
      <v-card align="center" flat class="card dt-border">
        <p class="dt-orange__text">GIFTCARD</p>
        <span>{{ giftcard }}</span>
      </v-card>
    </v-col>
    <v-col cols="6">
      <v-card align="center" flat class="card dt-border">
        <p class="dt-orange__text">RATE</p>
        <span>{{ rate }}</span>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
    props:{
        amount:{
            type:Number
        },
        store:{
            type : String
        },
        giftcard:{
          type : String
        },
        rate:{
          type : Number
        }
    }
}
</script>

<style lang="scss" scoped>
@import './styles.scss'
</style>